<template>
  <div id="main">
    <div class="fof">
      <h2>Link has</h2><h1> Expired</h1><br> <h4>Please scan again to make the purchase...</h4>

      <div class="stickBottom">
        <figure class="about-img2">
          <img src="../assets/static/images/illustrations/QRscanning2.svg" />
        </figure>
      </div>
    </div>
  </div>
</template>

<script>

export default {
metaInfo: {
      title: 'expar',
      titleTemplate: null,
}
}

</script>

<style lang="css">
*{
    transition: all 0.6s;
}

html {
    height: 100%;
}

body{
    font-family: 'Lato', sans-serif;
    color: #888;
    margin: 0;
}

#main{
    display: table;
    width: 100%;
    height: 100vh;
    text-align: center;
}

.fof{
    padding-top: 7em;
	  display: table-cell;
	  vertical-align: middle;
}

.fof h1{
	  font-size: 50px;
	  display: inline-block;
	  padding-right: 12px;
	  animation: type .5s alternate infinite;
}

@keyframes type{
	  from{box-shadow: inset -3px 0px 0px #888;}
	  to{box-shadow: inset -3px 0px 0px transparent;}
}

.stickBottom {
  left: 0;
  bottom: 0; 
}

.about-img2 {
  display: inline-block;
  width: 100%;
  margin-top: 0px;
  text-align: center;
  vertical-align: top;
}
</style>
